import apiClient from '../../../services/session/apiClient'

export const generateConfig = (config) => {
  return apiClient.post('/instantAuditsAdmin/generateConfig', config)
}

export const updateRateLimits = ({_id, rateLimits, hostnameRateLimits, hostname, deleted}) => {
  return apiClient.post('/instantAuditsAdmin/updateRateLimits', {_id, rateLimits, hostnameRateLimits, hostname, deleted})
}


export const configs = (apiTokens = [], accountIds = []) => {
  return apiClient.get('/instantAudits/configs', {params: {apiTokens, accountIds}})
}

export const tokens = (accountId) => {
  return apiClient.get('/instantAudits/tokens', {params: {accountId}})
}

export const usage = (apiTokens, accountIds, from, to, limit = 10, offset = 0, sortField, sortOrder) => {
  return apiClient.get('/instantAudits/usage', {params: {apiTokens, accountIds, from, to, limit, offset, sortField, sortOrder}})
}

export const usageStats = (apiTokens, accountIds, from, to) => {
  return apiClient.get('/instantAudits/usage/stats', {params: {apiTokens, accountIds, from, to}})
}



